import { useQuery } from '@tanstack/react-query'
import { getIngredientAutocomplete } from './recipes.service'

export function useIngredientAutocomplete(query: string) {
  return useQuery({
    queryKey: ['ingredients', 'autocomplete', query],
    queryFn: () => getIngredientAutocomplete(query),
    enabled: query.length >= 1,
    staleTime: 60 * 1000,
  })
}
